import { type FC } from 'react'

import './_avatarHolder.scss'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

import avatarPlaceholder from 'assets/images/user_placeholder.png'
import { Icons } from 'helpers/icons'

interface AvatarHolderProps {
  userId?: string
  img: string
  size: string
  customClass?: string
  isOnline?: boolean
  isLive?: boolean
  hasHeart?: boolean
  hasDollar?: boolean
  hasDiamond?: boolean
  hasStory?: boolean
  storyRead?: boolean
  username?: string
  dataQuery?: readonly any[]
  sponsored_post?: boolean
}

const AvatarHolder: FC<AvatarHolderProps> = ({
  userId,
  img,
  size,
  customClass,
  isOnline,
  isLive,
  hasHeart,
  hasDollar,
  hasDiamond,
  hasStory,
  storyRead,
  username,
  dataQuery,
  sponsored_post
}) => {
  const { t } = useTranslation()

  return (
    <div
      className={`avatarholder ${
        hasStory
          ? storyRead
            ? 'avatarholder__story--read'
            : 'avatarholder__story--unread'
          : ''
      } avatarholder--${size} ${customClass ?? ' '}`}
    >
      {isOnline ? <div className="avatarholder__online" /> : ''}
      {isLive ? <div className="avatarholder__live">{t('live')}</div> : ''}

      {userId && username && !sponsored_post ? (
        <Link to={`/${username}/`}>
          <img src={img || avatarPlaceholder} alt="Avatar" />
        </Link>
      ) : (
        <img src={img || avatarPlaceholder} alt="Avatar" />
      )}
      {hasHeart ?? hasDollar ?? hasDiamond ? (
        <div className="avatarholder__blueicon">
          {hasHeart && (
            <img
              className="avatarholder__blueicon--heart"
              src={Icons.avatar_heart}
              alt={t('heart')}
            />
          )}
          {hasDollar && (
            <img
              className="avatarholder__blueicon--dollar"
              src={Icons.avatar_dollar}
              alt={t('dollar')}
            />
          )}
          {hasDiamond && (
            <img
              className="avatarholder__blueicon--diamond"
              src={Icons.avatar_diamond}
              alt={t('diamond')}
            />
          )}
        </div>
      ) : (
        ''
      )}
    </div>
  )
}

export default AvatarHolder